import { RatingType } from '@src/clients/seeker/api';

export const ImageSearchParams = {
  DateRange: 'Date Range',
  CloudCover: 'Cloud Coverage',
  Satellites: 'Satellites',
  Bbox: 'bbox'
} as const;

export const ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
  TOOL: 'tool'
} as const;

export const RATING_TYPES = {
  POSITIVE: RatingType.POSITIVE,
  NEGATIVE: RatingType.NEGATIVE,
  NEUTRAL: RatingType.NEUTRAL
} as const;

export const TOOL_TYPES = {
  INSIGHTS: 'InsightsHandlerTool',
  INDEX: 'IndexAgent',
  INFORMATION: 'InformationRetrieval',
  IMAGE_SEARCH: 'SatelliteImagerySearch'
} as const;

export const AURORA_INTELLIGENCE_THUMBNAIL_16 = `${window.location.origin}/images/aurora_intelligence.png`;

export const MULTI_CHAT_STEPS = {
  WELCOME: 'WELCOME',
  CHAT: 'CHAT'
} as const;

export const COPILOT_HISTORY_LIMIT = 10;

export const HISTORY_ATTRS_DEFAULT_VALUE = {
  offset: 0,
  chatList: [],
  hasMore: false
};
